import React from 'react';
import { Badge, Button, Group, Skeleton, Stack, Text, ThemeIcon, Tooltip } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';
import { PopupEventVendorDetailsUpcoming } from '../types';
import useEventConfirm from './useEventConfirm';

type PopupUpcomingConfirmProps = {
  event: PopupEventVendorDetailsUpcoming;
};

const PopupUpcomingConfirm: React.FC<PopupUpcomingConfirmProps> = ({ event }) => {
  const { loading, onConfirm, loadingConfirm, canConfirm } = useEventConfirm({
    id: event.id,
    skip: event.confirmed,
  });

  if (loading) {
    return (
      <>
        <Skeleton mt="md" h="md" w="60%" />
        <Skeleton mt="md" h="xl" w="40%" />
      </>
    );
  }

  return (
    <Stack p="sm" bdrs="md" bd="1px solid var(--mantine-color-gray-4)" gap="xs">
      <Group gap="sm" justify="space-between" align="center">
        <Group gap="xs" align="center">
          <Text>Are you going to this Popup Event?</Text>
          {event.confirmed && (
            <Badge size="sm" p="xs" color="green" radius="md" variant="light">
              Confirmed
            </Badge>
          )}
        </Group>
        <Tooltip
          multiline
          withArrow
          w={260}
          position="bottom"
          transitionProps={{ transition: 'fade-down', duration: 200 }}
          label="If you are no longer able to attend an event after confirming, please contact your Fooda account manager. Cancellations will incur a fee."
        >
          <ThemeIcon variant="white">
            <IconInfoCircle size={18} />
          </ThemeIcon>
        </Tooltip>
      </Group>
      {!event.confirmed && (
        <Group gap="xs" justify="space-between" align="center">
          <Group gap="xs" align="center">
            <Text>Status:</Text>
            <Badge size="sm" p="xs" color="red" radius="md" variant="light">
              Unconfirmed
            </Badge>
          </Group>
          <Button
            variant="outline"
            disabled={!canConfirm}
            loading={loadingConfirm}
            onClick={onConfirm}
          >
            Yes, we'll be there
          </Button>
        </Group>
      )}
      {!canConfirm && !event.confirmed && <Text fz="sm">To be confirmed by manager</Text>}
    </Stack>
  );
};

export default PopupUpcomingConfirm;
